import { render, staticRenderFns } from "./couponManualAdd.vue?vue&type=template&id=67a9e380&scoped=true&"
import script from "./couponManualAdd.vue?vue&type=script&lang=js&"
export * from "./couponManualAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a9e380",
  null
  
)

export default component.exports